export default __webpack_public_path__ + "static/media/sphere-third.5a0fb8ed.png";